<template>
  <div>
    <source-layer v-model="sourceLayer" :sourceLayers="sourceLayers" :validated="validated"></source-layer>

    <b-row v-if="validated && (distanceIsEmpty || distanceIsInvalid)">
      <b-col offset="3" cols="9">
        <small class="text-danger" v-if="distanceIsEmpty">
            Należy podać odległość.
        </small>
        <small class="text-danger" v-if="distanceIsInvalid">
            Odległość jest niepoprawna. Powinna przyjąć wartość od 1 do 5000.
        </small>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="3">
        <label for="distance">Odległość</label>
      </b-col>
      <b-col cols="9">
        <b-form-input id="distance" v-model.number="distance" placeholder="Wpisz" type="number" :state="validated && (distanceIsEmpty || distanceIsInvalid) ? false : null"></b-form-input>
      </b-col>
    </b-row>
    
    <reference-layer :readonly="true"></reference-layer>
  </div>
</template>

<script>
import SourceLayer from './SourceLayer';
import ReferenceLayer from './ReferenceLayer';
import { FEATURES_PROXIMITY_ANALYSIS } from '../../store/actions.type';

export default {
  components: {
    SourceLayer,
    ReferenceLayer
  },
  data() {
    return {
      sourceLayer: null,
      distance: null,
      validated: false
    }
  },
  props: {
    sourceLayers: { type: Array, required: true },
    hasErrors: { type: Boolean, default: false },
    waitingForResponse: Boolean
  },
  computed: {
    sourceLayerIsEmpty() {
      return !this.sourceLayer;
    },
    distanceIsEmpty() {
      return this.distance === null || this.distance === "";
    },
    distanceIsInvalid() {
      return !this.distanceIsEmpty && (this.distance < 1 || this.distance > 5000);
    },
    formHasErrors() {
      return this.sourceLayerIsEmpty || this.distanceIsEmpty || this.distanceIsInvalid;
    }
  },
  watch: {
    formHasErrors(value) {
       this.$emit('update:hasErrors', value);
    }
  },
  methods: {
    async submit() {
      this.validated = true;

      if (!this.formHasErrors) {
        const analysisData = {
          sourceLayerId: this.sourceLayer.id,
          analysisType: 'sasiedztwo',
          referenceLayerId: this.$store.getters.featuresLayer.id,
          sourceLayerType: this.sourceLayer.type,
          maxDistance: this.distance,
          geometry: this.sourceLayer.geojson
        };

        this.$emit('update:waitingForResponse', true);
        await this.$store.dispatch(FEATURES_PROXIMITY_ANALYSIS, analysisData);
        this.$emit('update:waitingForResponse', false);
      } 
      else {
        this.$emit('update:hasErrors', true);
      }
    }
  }
}
</script>